import { render, staticRenderFns } from "./shopHeader.vue?vue&type=template&id=eb1056f0&scoped=true"
import script from "./shopHeader.vue?vue&type=script&lang=js"
export * from "./shopHeader.vue?vue&type=script&lang=js"
import style0 from "./shopHeader.vue?vue&type=style&index=0&id=eb1056f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb1056f0",
  null
  
)

export default component.exports